/* Mobile menu burger toggle: Esc closes, focus moves in and back, scroll locks,
   any nav tap or a resize past phone width closes it */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation && navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-controls', navigation.id);

    function setOpen(open) {
        if (navigation.classList.contains('is-open') === open) return;
        navigation.classList.toggle('is-open', open);
        document.documentElement.classList.toggle('pt-menu-open', open);
        burger.setAttribute('aria-expanded', String(open));
        if (open) {
            const first = navigation.querySelector('.gh-navigation-menu .nav a');
            if (first) setTimeout(function () { first.focus({preventScroll: true}); }, 60);
        } else if (navigation.contains(document.activeElement)) {
            burger.focus({preventScroll: true});
        }
    }

    burger.addEventListener('click', function () {
        setOpen(!navigation.classList.contains('is-open'));
    });
    document.addEventListener('keydown', function (e) {
        if (!navigation.classList.contains('is-open')) return;
        if (e.key === 'Escape') {
            setOpen(false);
            burger.focus({preventScroll: true});
            return;
        }
        if (e.key !== 'Tab') return;
        /* keep Tab inside the open sheet */
        const items = Array.prototype.filter.call(
            navigation.querySelectorAll('a[href], button:not([disabled]), input'),
            function (el) { return el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden'; }
        );
        if (!items.length) return;
        const first = items[0], last = items[items.length - 1];
        if (!navigation.contains(document.activeElement)) {
            e.preventDefault(); first.focus();
        } else if (e.shiftKey && document.activeElement === first) {
            e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault(); first.focus();
        }
    });
    navigation.addEventListener('click', function (e) {
        if (e.target.closest('.gh-navigation-menu a, .gh-navigation-actions a')) setOpen(false);
    });
    window.matchMedia('(min-width: 992px)').addEventListener('change', function (e) {
        if (e.matches) setOpen(false);
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();